import { Box, Stack, Typography } from "@mui/material"
import { ThemeContext } from "../../../Shared/Theme/ThemeContext"
import { useContext } from "react";

export function StationsButton({...params}){

    const { mode } = useContext(ThemeContext);

    let stationsButtonState = params.stationsButtonState
    let setStationsButtonState = params.setStationsButtonState
    let handleClick = params.handleClick

    let lightPaths = ["/icons/icons-light/icon-stations-light-active.svg", "/icons/icons-light/icon-stations-light-default.svg", "/icons/icons-light/icon-stations-light-hover.svg"]
    let darkPaths = ["/icons/icons-dark/icon-stations-dark-active.svg", "/icons/icons-dark/icon-stations-dark-default.svg", "/icons/icons-dark/icon-stations-dark-hover.svg"]

    let lightColors = ["#02203B", "#06569D", "#138BF6"]
    let darkColors = ["#138BF6", "#75BCFA", "#D8ECFD"]

    let onButtonPage = false
    let url = window.location.pathname
    if (url === '/stationspage') onButtonPage = true

    const handleButtonHover = (event) => {
        event.preventDefault()
        if (onButtonPage) setStationsButtonState('hover')
        else if (stationsButtonState !== 'active') setStationsButtonState('hover')
    }

    const handleButtonMouseOut = (event) => {
        event.preventDefault()
        setStationsButtonState('default')
        if (onButtonPage) setStationsButtonState('active')
        else if (stationsButtonState !== 'active') setStationsButtonState('default')
    }

    let imagePath = ''
    let labelColor = ''

    if (mode === 'light'){
        if (stationsButtonState === 'active') {imagePath = lightPaths[0]; labelColor = lightColors[0]}
        else if (stationsButtonState === 'default') {imagePath = lightPaths[1]; labelColor = lightColors[1]}
        else if (stationsButtonState === 'hover') {imagePath = lightPaths[2]; labelColor = lightColors[2]}
    } 
    else if (mode === 'dark'){
        if (stationsButtonState === 'active') {imagePath = darkPaths[0]; labelColor = darkColors[0]}
        else if (stationsButtonState === 'default') {imagePath = darkPaths[1]; labelColor = darkColors[1]}
        else if (stationsButtonState === 'hover') {imagePath = darkPaths[2]; labelColor = darkColors[2]}
    } 

    let labelFormatting = params.labelFormatting
    let labelStyling = {color: labelColor, width: '53px', height: '10px'}

    return (
        <Stack width={'71px'} height={'55px'} direction={'column'} alignItems={'center'} zIndex={100}
            onMouseOut={(event) => handleButtonMouseOut(event)} 
            onMouseOver={(event) => handleButtonHover(event)}
            onClick={(event) => handleClick(event)}>

            <Box component="img" src={imagePath} width={'25.5px'} height={'45px'} paddingBottom={'10px'}  id={"StationsButton"}/>
            <Typography sx={[labelFormatting, labelStyling]}>Stations</Typography>
        </Stack>
    )
}
